module.exports = __webpack_public_path__ + "img/logo-CGcourtage.83e74255.svg";